


















































import { Vue, Component } from 'vue-property-decorator'
import ExamSelect from '@/components/select/ExamSelect.vue'
import ExamRoomSelect from '@/components/select/ExamRoomSelect.vue'
import {
  fetchRecord,
  fetchAllRecord,
  triggerPrint
} from '@/service/exam/record'
import { randKey } from '@/utils/random'
import { Exam } from '@/models/exam'
import { ExamRoom } from '@/models/exam/room'
import { ExamRoomRecord } from '@/models/exam/record'
import PrintExamRoomArrangement from './components/PrintExamRoomArrangement.vue'

@Component({
  components: {
    ExamSelect,
    ExamRoomSelect,
    PrintExamRoomArrangement
  }
})
export default class ExamRoomArrangement extends Vue {
  exam = ({ id: null } as unknown) as Exam
  room = ({ id: null } as unknown) as ExamRoom
  list = [] as ExamRoomRecord[]
  getKey = randKey
  size = 0
  sizeOptions = [
    { label: '打印全部', value: 0 },
    { label: '每次50页', value: 50 },
    { label: '每次30页', value: 30 },
    { label: '每次20页', value: 20 },
    { label: '每次10页', value: 10 }
  ]

  get disabledPrint() {
    return !this.exam.id || !this.room.id
  }

  get disabledPrintAll() {
    return !this.exam.id
  }

  handleExamChange(exam: Exam) {
    this.exam = exam
  }

  async handleRoomChange(room: ExamRoom) {
    this.room = room
    const data = await fetchRecord(room.examId, room.roomId)
    this.list = data ? [data] : []
  }

  handlePrint() {
    this.$htmlToPaper('print')
  }

  async handlePrintAll() {
    const iterator = await fetchAllRecord(this.exam.id, this.size)
    for (const list of iterator) {
      this.list = list
      const re = await triggerPrint('print')
      if (!re) break
    }
  }
}
